import React from "react";
import { NavLink } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import careerTeam from "../assets/img/career-team.png";

import "../assets/css/Careers.css";

const benefits = [
  {
    title: "Health & wellbeing",
    text: "Health coverage and wellbeing support designed to fit real life, not just the job.",
  },
  {
    title: "Learning & development",
    text: "Real investment in your growth; training, coaching, and a path that goes somewhere.",
  },
  {
    title: "People-first culture",
    text: "Support that treats you as a person first not just a seat on the org chart.",
  },
];

const Careers = () => {
  return (
    <div id="careers">
      <Navbar />

      {/* Hero */}
      <section className="careers-hero">
        <div className="container pb-3 ">
          <span className="section-tag">CAREERS</span>

          <h1>
            Build the Future of Digital Operations
            <wbr /> and Your Career.
          </h1>

          <p>
            Join a team of thinkers, innovators, and problem-solvers
            transforming how global businesses operate. At Outcess, your work
            drives real impact from day one.
          </p>

          <NavLink to="/current-openings">
            <button className="ccsnl-btn">See Open Roles</button>
          </NavLink>
        </div>
      </section>

      {/* Shape What's Possible */}
      <section className="career-showcase  ">
        <div className="container showcase-grid ">
          <div className="showcase-content">
            <span className="section-tag">SHAPE WHAT'S POSSIBLE</span>

            <h2>
              Turn ambitious ideas into what
              <br />
              clients actually use.
            </h2>

            <p>
              We're building tomorrow's customer engagement infrastructure
              today. Guide programs that accelerate growth for the people on
              your team, and help set the standard the rest of the company works
              to.
            </p>
          </div>

          <div className="showcase-image">
            <img src={careerTeam} alt="Team collaboration" />
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section className="career-benefits">
        <div className="container">
          <div className="benefits-header">
            <span className="section-tag">WHY CHOOSE OUTCESS</span>

            <p>
              Build your career alongside a team driven by excellence,
              innovation, and continuous learning. We offer an environment where
              your work directly shapes the future of customer experience and
              digital operations.
            </p>
          </div>

          <div className="benefits-grid">
            {benefits.map((item, index) => (
              <div
                key={index}
                className="benefit-card"
                data-aos="fade-up"
                data-aos-delay={index * 150}
              >
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="careers-cta">
        <div className="container">
          <h2>Come build the next chapter with us.</h2>

          <p>See what's open right now and join the talent community.</p>

          <NavLink to="/current-openings">
            <button className="ccsnl-btn">See Open Roles</button>
          </NavLink>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Careers;
